import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-login-feed-card',
  templateUrl: './login-feed-card.component.html',
  styleUrls: ['./login-feed-card.component.css']
})
export class LoginFeedCardComponent {

  @Input() post: any;

  constructor() { }

  sharePost(event: any, shareLink: string) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    window.open(shareLink, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login-feed/login-feed-card/login-feed-card.component.ts